export const API_URL ='https://cliente.angonet.ao/api';


//export const API_URL = 'http://127.0.0.1:8081/api';